export function save(key, value) {
    let windowStorage = window.localStorage;
    if(!windowStorage){
        return false;
    }

    let canUseStorage = 'storage' in navigator && 'estimate' in navigator.storage
    if (!canUseStorage) {
        return false;
    }

    try {
        localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
        console.log("Cached object could not be stored into the localStorage");
        console.error(e);
    }
}

export function load(key) {
    // Other caching (i.e. not My List).
    // Uses Local Storage.
    const loadedItem = localStorage.getItem(key);

    // if key doesn't exist
    if(loadedItem === null) return null;

    return JSON.parse(loadedItem);
}

export function saveMergeObject(key, value, defaultValue = {}) {
    const old = load(key) ?? defaultValue;
    save(key, {
        ...old,
        ...value,
    });
}